/**
 * @file API 路徑配置
 * @description 定義所有 API 端點的路徑常數，集中管理 API URLs
 */

/** API 基礎路徑配置 */
const config = {
  template: 'v1',
  backStagePosts: 'backStage/posts',
  backStagePostImages: 'backStage/postImages',
  backStageCategory: 'backStage/category',
  auth: 'auth',
  member: 'member',
  test: 'test',
  posts: 'posts',
  category: 'category',
  common: 'common',
  tg: 'tg'
} as const;

/** 範本相關 API 路徑 */
const template = {
  getTemplate: `${config.template}/test`
} as const;

/** 認證相關 API 路徑 */
const auth = {
  login: `${config.auth}/login`,
  getAuthInfo: `${config.auth}/getAuthInfo`,
  refresh: `${config.auth}/refresh`,
  logout: `${config.auth}/logout`,
  getDashboard: `${config.auth}/getDashboard`
} as const;

/** 測試相關 API 路徑 */
const test = {
  punchme: `${config.test}/punchme`
} as const;

/** 文章相關 API 路徑 (前台) */
const posts = {
  getPostList: `${config.posts}/getPostList`,
  getPostById: `${config.posts}/getPostById`
} as const;

/** 分類相關 API 路徑 */
const category = {
  getCategoryList: `${config.category}/getCategoryList`,
  getCategoryPostList: `${config.category}/getCategoryPostList`
} as const;

/** 共用功能 API 路徑 */
const common = {
  getAsideCardDetail: `${config.common}/getAsideCardDetail`
} as const;

/** 後台管理 API 路徑 */
const backStage = {
  getBackStagePostList: `${config.backStagePosts}/getBackStagePostList`,
  getBackStagePostById: `${config.backStagePosts}/getBackStagePostById`,
  postBackStageAddPost: `${config.backStagePosts}/postBackStageAddPost`,
  patchBackStageEditPost: `${config.backStagePosts}/patchBackStageEditPost`,
  deleteBackStagePost: `${config.backStagePosts}/deleteBackStagePost`,
  getBackStageCategoryOptions: `${config.backStageCategory}/getBackStageCategoryOptions`
} as const;

/** 後台分類管理 API 路徑 */
const backStageCategory = {
  getBackStageCategoryList: `${config.backStageCategory}/getBackStageCategoryList`,
  postBackStageAddCategory: `${config.backStageCategory}/postBackStageAddCategory`,
  patchBackStageEditCategory: `${config.backStageCategory}/patchBackStageEditCategory`,
  postCheckCategoryDeletable: `${config.backStageCategory}/postCheckCategoryDeletable`,
  deleteBackStageCategory: `${config.backStageCategory}/deleteBackStageCategory`
} as const;

/** 後台文章圖片 API 路徑 */
const postImages = {
  getPostImages: `${config.backStagePostImages}/getPostImages`,
  uploadPostImage: `${config.backStagePostImages}/uploadPostImage`,
  batchUploadPostImages: `${config.backStagePostImages}/batchUpload`,
  updatePostImage: `${config.backStagePostImages}/updatePostImage`,
  deletePostImage: `${config.backStagePostImages}/deletePostImage`,
  getImageBlob: `${config.backStagePostImages}/getImageBlob`
} as const;

/** Telegram 相關 API 路徑 */
const tg = {
  postTelegramMsg: `${config.tg}/postTelegramMsg`
} as const;

export default {
  template,
  auth,
  test,
  posts,
  category,
  common,
  backStage,
  backStageCategory,
  postImages,
  tg
};
